export const SKIN_PLATFORM_TYPE = 4;

export const skinTextLimits = [
  { min: 5, max: 14 },
  { min: 5, max: 10 },
];

export const skinSizes = [
  {
    id: 40001,
    key: "pc",
    name: "PC端皮肤",
    fileName: "PC端F34848",
    width: 960,
    height: 335,
    previewHeight: 260,
    previewScale: 1,
    background: {
      width: 1000,
      height: 250,
      x: -20,
      y: 0,
      fadeStop: 75,
    },
    element: {
      width: 600,
      height: 150,
      x: 180,
      y: -10,
    },
    text: {
      subTitleSize: 16,
      mainTitleSize: 20,
      subTitleY: 19.5,
      titleGap: 5,
    },
    card: {
      width: 600,
      height: 173.5,
      x: 180,
      y: 86.5,
      topRadius: 12,
    },
  },
  {
    id: 40002,
    key: "mobile",
    name: "移动端皮肤",
    fileName: "移动端F34848",
    width: 375,
    height: 260,
    previewHeight: 260,
    previewScale: 1,
    background: {
      width: 600,
      height: 150,
      x: -112.5,
      y: 0,
      fadeStop: 60,
    },
    element: {
      width: 350,
      height: 87.5,
      x: 12.5,
      y: 89,
    },
    text: {
      subTitleSize: 18,
      mainTitleSize: 28,
      subTitleY: 54.5,
      titleGap: 5,
    },
    card: {
      width: 351,
      height: 173.5,
      x: 12,
      y: 167.5,
      topRadius: 16,
    },
  },
];

export const skinExportSizes = [
  {
    id: 40001,
    key: "pc",
    name: "PC端皮肤",
    fileName: "PC端F34848",
    width: 1920,
    height: 670,
    background: {
      width: 2000,
      height: 500,
      x: -40,
      y: 0,
      fadeStop: 75,
    },
    element: {
      width: 1000,
      height: 250,
      x: 460,
      y: -20,
    },
    text: {
      subTitleSize: 32,
      mainTitleSize: 40,
      subTitleY: 39,
      titleGap: 10,
    },
    card: {
      width: 1200,
      height: 347,
      x: 360,
      y: 173,
      topRadius: 24,
    },
  },
  {
    id: 40002,
    key: "mobile",
    name: "移动端皮肤",
    fileName: "移动端F34848",
    width: 750,
    height: 470,
    background: {
      width: 1200,
      height: 300,
      x: -225,
      y: 0,
      fadeStop: 60,
    },
    element: {
      width: 700,
      height: 175,
      x: 25,
      y: 178,
    },
    text: {
      subTitleSize: 36,
      mainTitleSize: 56,
      subTitleY: 109,
      titleGap: 10,
    },
    card: {
      width: 702,
      height: 347,
      x: 24,
      y: 335,
      topRadius: 32,
    },
  },
];

export const defaultSkinTextStyle = {
  id: 0,
  styles: [
    {
      fontColor: "#fff",
      fontFamily: "阿里巴巴普惠体 Regular",
      isLabelStyle: true,
      showLabelStyle: false,
      labelStyle: "样式1",
    },
    {
      fontColor: "#fff",
      fontFamily: "阿里巴巴普惠体 Heavy",
    },
  ],
};

export const skinMap = {
  tagId: 0,
  backgroundId: 0,
  elementId: 0,
  textStyleId: 0,
  elementTypeId: 2,
  bgParameter: {
    src: "",
    tagBgColor: "#F34848",
    textShadowColor: "rgba(0,0,0,.2)",
  },
  elementImg: "",
  isAiElement: false,
  textValue: ["", ""],
  textStyle: JSON.parse(JSON.stringify(defaultSkinTextStyle.styles)),
};
